export default {"src":"/_next/static/media/pyth.4e927ff2.svg","height":1120,"width":3285,"blurWidth":0,"blurHeight":0};